<template>
    <div class="checkbox-container" @click="change">
        <div class="checkbox-itself" :class="{'checked': is_true}"></div>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'CheckBox',
        props: ['value'],
        computed: {
            is_true() {
                if (Array.isArray(this.value)) {
                    return this.value.includes(this.$attrs.value);
                } else {
                    return this.value;
                }
            }
        },
        methods: {
            change() {
                if (!Array.isArray(this.value)) {
                    this.$emit('input', !this.value);
                } else {
                    let index = this.value.indexOf(this.$attrs.value);
                    if (index >= 0) {
                        this.$emit('input', this.value.filter(item => item != this.$attrs.value));
                    } else {
                        let ret = this.value.map(e => e);
                        ret.push(this.$attrs.value);
                        this.$emit('input', ret);
                    }
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .checkbox-container {
        padding: 5px 5px 5px 0;
        cursor: pointer;
        display: flex;
        white-space: nowrap;
        align-items: center;
    }

    .checkbox-itself {
        width: 16px;
        height: 16px;
        display: block;
        float: left;
        flex-shrink: 0;
        &.checked {
            background-image: url(../images/checkboxes/agree_white.svg), url(../images/checkboxes/checkbox_checked_new.svg);
            background-repeat: no-repeat;
            background-position: 60% 56%, center;
        }
        &:not(.checked) {
            background: url(../images/checkboxes/checkbox_unchecked_new.svg) no-repeat center;
        }
    }

    .checkbox-itself + * {
        margin-left: 10px;
    }
</style>